/**
 * @generated SignedSource<<a026e73da8480b088365864db987986c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type AclInputEntry = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type CreatePlaylistMutation$variables = {
  acl: ReadonlyArray<AclInputEntry>;
  creator: string;
  entries: ReadonlyArray<string>;
  metadata: BasicMetadata;
};
export type CreatePlaylistMutation$data = {
  readonly createPlaylist: {
    readonly id: string;
  };
};
export type CreatePlaylistMutation = {
  response: CreatePlaylistMutation$data;
  variables: CreatePlaylistMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "creator"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entries"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadata"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "acl",
        "variableName": "acl"
      },
      {
        "kind": "Variable",
        "name": "creator",
        "variableName": "creator"
      },
      {
        "kind": "Variable",
        "name": "entries",
        "variableName": "entries"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "AuthorizedPlaylist",
    "kind": "LinkedField",
    "name": "createPlaylist",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePlaylistMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreatePlaylistMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "edb8913c83813d73843a929ea32c0f50",
    "id": null,
    "metadata": {},
    "name": "CreatePlaylistMutation",
    "operationKind": "mutation",
    "text": "mutation CreatePlaylistMutation(\n  $metadata: BasicMetadata!\n  $acl: [AclInputEntry!]!\n  $creator: String!\n  $entries: [ID!]!\n) {\n  createPlaylist(metadata: $metadata, acl: $acl, creator: $creator, entries: $entries) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "58ddf532ee598c04a7a4e5fb492d3808";

export default node;
